import { safeClone, ViewStream, ChannelPayloadFilter } from "spyne";
import { UIHeaderView } from "components/ui/ui-header-view";
import { UIFooterView } from "components/ui/ui-footer-view";
import { SidebarContainer } from "./ui/sidebar/sidebar-container";
import { Page404View } from "components/pages/page-404-view";
import { PageView } from "components/pages/page-view";
import { PageHome } from "components/pages/page-home";
import { PageTools } from "components/pages/page-tools";
import { PageDocs } from "components/pages/page-docs";
import { PageEarlyAccess } from "components/pages/page-early-access";
import { PageQuickStart } from "components/pages/page-quick-start";
import { PageInvestors } from 'components/pages/page-investors';
import { PageDeck } from 'components/pages/page-deck';
import { PageArchitectureAsData } from 'components/pages/page-arch-as-data';
import { PageBlog} from 'components/pages/page-blog';
import { PagePricing } from 'components/pages/page-pricing';
import { PageOverview } from "components/pages/page-overview";
import { PageReference } from "components/pages/page-reference";
import { PageConfigurator } from "components/pages/page-configurator";
import { PageCompare } from "components/pages/page-compare";
import { PageCallback } from "components/pages/page-callback";
import { ExternalLinksLauncher } from "components/external-links-launcher";
import { UIExternalEventsLauncher } from "components/ui/ui-external-events-launcher";
import { AuthTraits } from "traits/auth-traits";
import { AuthAppTraits } from 'traits/auth-app-traits';
import { LocalStorageTraits } from "traits/local-storage-traits";
//import {sendPostMsg} from '../../../../spyne-plugin-postmsg';
import {sendPostMsg} from '@franciscobatista/spyne-plugin-post-msg-tmp';
import { StageViewAuthLinks} from 'components/stage-view-auth-links';
import {AppDataTraits} from 'traits/app-data-traits';

export class StageView extends ViewStream {
  static #accessToken = null;
  static #currentPageId = undefined;
  static #currentPage = undefined;

  constructor(props = {}) {
    props.id = "stage-view";
    props.traits = [AuthTraits, AuthAppTraits, LocalStorageTraits];
    props.isAuthenticated = false;
    props.userProfile = {};
    props.channels = ["CHANNEL_UI", "CHANNEL_AUTH", "CHANNEL_SPYNE_DOCS_DATA"];
    props.template = require("./templates/app-view.tmpl.html");
    super(props);
  }

  addActionListeners() {
    // return nexted array(s)

    const authPayloadFilter = new ChannelPayloadFilter({
      type: "auth0",
    });

    return [
      ["CHANNEL_UI_CLICK_EVENT", "auth$onUIEvent", authPayloadFilter],
      ["CHANNEL_AUTH_CONFIG_LOADED_EVENT", "onAuthInit"],
      ["CHANNEL_APP_ROUTE_PAGE_CHANGE_EVENT", "onPageChangeEvent"],
      ["CHANNEL_AUTH_APP_CREATE_REQUEST_EVENT", "onCreateAppEvent"],
      ["CHANNEL_SPYNE_DOCS_DATA_LOADED_EVENT", "onAppDataReturned"],
      ["CHANNEL_AUTH_APP_LAUNCH_PREVIEW_WINDOW_EVENT", "authApp$OnOpenPreviewWindow"],
      ["CHANNEL_AUTH_WINDOW_REQUEST_EVENT", "onPreviewWindowPostMsgRequest"]
    ];
  }

  async onCreateAppEvent(e) {
    const config = StageView.#currentPage?.config;
    const { isAuthenticated } = this.props;

/*   //console.log(      "CREATE APP CONFIG IS ",
      { config, isAuthenticated, e },
      StageView.#currentPage,
    );*/
    if (config && isAuthenticated === true) {
      const action = "CHANNEL_AUTH_APP_CREATE_GENERATING_INITIALIZED_EVENT";
      this.sendInfoToChannel("CHANNEL_AUTH", { action }, action);

     //console.log("TOKEN1 IS ",StageView.#accessToken, this);

      this.authApp$CreateUserApp(config, StageView.#accessToken);
    } else {
      this.localStorage$setProp("callbackPageId", "configure");
      await this.props.auth0.loginWithRedirect();
    }
  }

  async onAuthInit(e) {




   // const isUpgradeSuccess = authState === 'success' && localStorage.getItem()



    const token = await this.auth$OnInit(e);

    /**
     *
     * TODO: Get and Set User Plan, pass to StagViewAuthLinks
     *
     *
     * */


    const setToken = (tk) => {
      const { isAuthenticated, userProfile } = this.props;
      StageView.#accessToken = tk;

      const onTkPromise = (t)=>console.log("THE T IS ",t);

      //tk.then(onTkPromise)

     //console.log("TOKEN RECVD1 ", {e,token},typeof token);

      if (StageView.#currentPageId === "configure") {
        const pageConfigurator = StageView.#currentPage;
        pageConfigurator.setAccessToken(tk);
        pageConfigurator.props.authData.isAuthenticated = isAuthenticated;
        pageConfigurator.props.authData.userProfile = userProfile;
      }

     //console.log("TOKEN RECVD ", tk);

    };


    if (typeof token === 'string'){
      setToken(token);
    } else if (token !== undefined) {
      token.then(setToken);
    }

    const {userProfile, userRecord, auth0, isAuthenticated} = this.props;


   //console.log("TK AND E ",typeof token,{e},this.props);

    new StageViewAuthLinks({
      isAuthenticated,
      auth0,
      userProfile,
      userRecord,
      token:StageView.#accessToken
    }).appendToNull();


  }

  onCallback(e) {
    this.auth$ResetCallback(e);
  }

  #getClass(pageId) {
    const hash = {
      home: PageHome,
      "quick-start": PageQuickStart,
      docs: PageDocs,
      tools: PageTools,
      deck: PageInvestors,
      "early-access": PageEarlyAccess,
      investors: PageDeck,
      compare: PageCompare,
      callback: PageCallback,
      "architecture-as-data" : PageArchitectureAsData,
      "getting-started": PageQuickStart,
      Overview: PageOverview,
      blog: PageBlog,
      configure: PageConfigurator,
      reference: PageReference,
      pricing: PagePricing,
      plans: PagePricing,
      404: Page404View,
    };
    return hash[pageId] || PageView;
  }

  sendResetRequestEvent() {
    const getPageIdFromLocalStorage = () => {
      let pageId = "404";
      const localStorageObj = JSON.parse(
        window.localStorage.getItem("spyneDocs1"),
      );

      return localStorageObj?.pageId !== undefined
        ? localStorageObj.pageId
        : pageId;
    };

    const pageId = getPageIdFromLocalStorage();
    const eventPreventDefault = true;
    const stage = "";
    const section = "";
    const routeData = { pageId, eventPreventDefault };

    //console.log("SEND RESET REQUEST EVENT ",{pageId, eventPreventDefault, routeData});
    const delayer = () => {
      this.sendInfoToChannel("CHANNEL_ROUTE", {
        pageId,
        stage,
        section,
        eventPreventDefault,
        routeData,
      });
/*     //console.log(
        "SENDING ROUTE ",
        { pageId, eventPreventDefault },
        "CHANNEL_ROUTE_CHANGE_EVENT",
      );*/
    };

    window.setTimeout(delayer, 200);
    // const action = "CHANNEL_AUTH_CALLBACK_RESET_REQUEST_EVENT";
    // this.sendInfoToChannel("CHANNEL_AUTH", {action}, action);
  }

  onPageChangeEvent(e) {
    const { cardExistsBool, payload } = e;
    const { routeData, data, cardState, docsBreadcrumbData, isDeepLink } = payload;
    const { isExpanded, pageId } = routeData;
    const PageClass = this.#getClass(pageId);
    if (!cardState) {
      //SpyneApp.pluginsFn.disableScrollLock();
    }

    //console.log("IS DEEP LINK ", {e, isDeepLink})

    if (isDeepLink){
      document.body.classList.remove('unloaded');
    }

    const appData = this.clonedData();
    const getPageDataHash = {
      docs: () => data.spyneDocsData,
      reference: () => appData.referencePageContent,
      configure: () => appData.configuratorPageContent,
      blog: ()=> appData.blogContent,
      "architecture-as-data": () => appData.archContent
    };

    //const pageData = pageId === 'docs' ? data.spyneDocsData : data;

    const pageData = getPageDataHash[pageId] ? getPageDataHash[pageId]() : data;
    this.props.el$("#page-container").setClass(`page-${pageId}`);

    const { userProfile, isAuthenticated } = this.props;
    const authData = { userProfile, isAuthenticated };
    //console.log("PAGEID ", { pageId, appData, authData, pageData, data });

    const currentPage = new PageClass({
      pageData,
      appData,
      authData,
      routeData,
      pageId,
      cardExistsBool,
      isDeepLink,
      docsBreadcrumbData,
    });

    StageView.#currentPageId = pageId;
    StageView.#currentPage = currentPage;

    if (!isExpanded) {
      const timerStr = `page-test:${pageId}`;
    //  console.time(timerStr);
      this.prependView(currentPage, "#page-container");
    }

    if (pageId === "callback") {
      requestAnimationFrame(this.sendResetRequestEvent.bind(this));
    } else {
      window.localStorage.setItem("spyneDocs1", JSON.stringify({ pageId }));
    }
  }

  broadcastEvents() {
    // return nexted array(s)
    return [];
  }

  clonedData() {
    //console.log("cloned data ",this.props.appData, this.props.spyneDocsData)
    return Object.assign(
      {},
      safeClone(this.props.appData),
      safeClone(this.props.spyneDocsData),
    );
  }

  onAppDataReturned(e) {
    const { payload } = e;
    const { appData, spyneDocsData } = payload;

    this.props.data = appData;
    this.props.appData = appData;
    this.props.spyneDocsData = spyneDocsData;

    const data = this.clonedData();

    this.addChannel("CHANNEL_APP_ROUTE");

    //console.log('all data is ',{data})
    this.prependView(new SidebarContainer({ data }), "#stage-content");
    this.prependView(new UIHeaderView({ data }));
    this.appendViewToParentEl(new UIFooterView({ data }), 'body', 2);

    new UIExternalEventsLauncher().appendToNull();
    //new ExternalLinksLauncher().appendToNull();
  }

  onPreviewWindowPostMsgRequest(e){
    const { sender } = e.payload?.metadata;
    const origin = sender;
    const { windowPreview } = this?.props;
    if (windowPreview) {
      const { userProfile, userRecord, isAuthenticated } = this?.props;
      const metadata = { origin, type: "authInfo" };
      const token = StageView.#accessToken;
      const msg = { userProfile, userRecord, isAuthenticated, token };

     //console.log("SENDING IS ", { msg, windowPreview, origin });

      sendPostMsg(msg, windowPreview, metadata);
    }


  }

  onRendered() {
    //this.addChannel("CHANNEL_SPYNE_DOCS_DATA");
  }
}
